import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function FinalCTASection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28" style={{ backgroundColor: '#4F6CFF' }}>
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="mb-8 text-3xl font-bold tracking-tight text-white md:text-4xl">
            {t('landing.finalCTA.headline')}
          </h2>

          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button size="lg" className="h-14 px-10 text-lg bg-white text-[#1A1F3C] hover:bg-white/90" asChild>
              <Link to="/signup">
                {t('landing.finalCTA.primaryCTA')}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="h-14 px-10 text-lg border-white/30 text-white hover:bg-white/10 bg-transparent" asChild>
              <Link to="/demo">
                {t('landing.finalCTA.secondaryCTA')}
              </Link>
            </Button>
          </div>

          <p className="mt-6 text-sm text-white/60">
            {t('landing.finalCTA.microcopy')}
          </p>
        </div>
      </div>
    </section>
  );
}
